import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { WorkspaceFileGitStatusComponent } from './workspace-file-git-status.component';

@NgModule({
  declarations: [WorkspaceFileGitStatusComponent],
  imports: [
    CommonModule,
    MatTooltipModule
  ],
  exports: [
    WorkspaceFileGitStatusComponent
  ]
})
export class WorkspaceFileGitStatusModule { }
